
import adminUrls from "@/urls/admin";
import {
  sendDeleteRequest,
  sendGetRequest,
  sendPatchRequest,
  sendPostRequest, sendPutRequest
} from "@/helper/requests";
import {executeRequest} from "@/store/modules/utils";
import {generateListUidToName} from "@/helper/uidToName";

const state = {
  interval: {
    items: [],
    loading: false,
    count: 0,
    detail: [],
    error: null,
  }
};

const getters = {
  getInterval: state => state.interval.items,
  getIntervalCount: state => state.interval.count,
  getCurrentUrl: state => state.interval.currentUrl,
  getIntervalDetail: state => state.interval.detail,
  isLoadingInterval: state => state.interval.loading,
  saveIntervalError: state => state.interval.error,
};

const actions = {
  loadIntervalDetail: ({commit}, {url, date,id, finalizer=()=>{}, catcher=()=>{}}) => {
    if (!url) url = adminUrls.ADMIN.INTERVAL.DETAIL(date,id)
    sendGetRequest(
        url, (data, url) => {
          commit('SET_INTERVAL_DETAIL', data);
          finalizer(data, url);
        }, (data, url) => {
          commit('SAVE_INTERVAL_ERROR', data);
          catcher(data, url);
        }
    )
  },
  loadRecordsTransfer: ({commit}, {url,data, date,id, finalizer=()=>{}, catcher=()=>{}}) => {
    if (!url) url = adminUrls.ADMIN.INTERVAL.TRANSFER(date,id)
    sendPostRequest(
        url,data, (data, url) => {
          finalizer(data, url);
        }, (data, url) => {
          catcher(data, url);
        }
    )
  },
  loadIntervalList: ({commit, getters}, {url,date, urlAppend, finalizer=()=>{}, catcher=()=>{}}) => {
    if (!url) {
      url = adminUrls.ADMIN.INTERVAL.LIST(date)
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingInterval) {
      commit('SET_INTERVAL_LOADING');
      sendGetRequest(
          url, (data, url) => {
            commit('SET_INTERVAL', data);
            commit('SET_INTERVAL_COUNT', data);
            commit('SET_INTERVAL_LOADING_END');
            finalizer(data, url);
          }, (data, url) => {
            commit('SET_INTERVAL_LOADING_END');
            commit('SAVE_INTERVAL_ERROR', data);
            catcher(data, url);
          }
      )
    }
  },
  changeIntervalBlock: ({dispatch, commit, getters}, {date,id,data, finalizer,catcher}) => {
    let url = adminUrls.ADMIN.INTERVAL.BLOCK(date,id)
    sendPutRequest( url, data, finalizer, catcher);
  },
  changeIntervalUnBlock: ({dispatch, commit, getters}, {date,id,data, finalizer,catcher}) => {
    let url = adminUrls.ADMIN.INTERVAL.UNBLOCK(date,id)
    sendPutRequest( url, data, finalizer, catcher);
  },
  createInterval: ({dispatch, commit, getters}, {date,data, finalizer=()=>{}, catcher=()=>{}}) => {
    let url = adminUrls.ADMIN.INTERVAL.CREATE(date)
    executeRequest('Interval', sendPostRequest, {url, data, finalizer, catcher}, {dispatch, commit, getters});
  },
  changeInterval: ({dispatch, commit, getters}, {date,id,data, finalizer,catcher}) => {
    let url = adminUrls.ADMIN.INTERVAL.UPDATE(date,id)
    executeRequest('Interval', sendPatchRequest, {url, data, finalizer, catcher}, {dispatch, commit, getters});
  },
  deleteInterval: ({dispatch, commit, getters}, {date,id, finalizer, catcher}) => {
    let url = adminUrls.ADMIN.INTERVAL.DELETE(date,id)
    executeRequest('Interval', sendDeleteRequest, {url, finalizer, catcher}, {dispatch, commit, getters});
  },

};

const mutations = {

  SET_INTERVAL: (state, obj) => {
    state.interval.items = obj
  },
  SET_INTERVAL_DETAIL: (state, value) => {
    state.interval.detail = value
  },
  SET_INTERVAL_COUNT: (state, value) => {
    state.interval.count = value
  },
  SET_INTERVAL_LOADING: (state) => {
    state.interval.loading = true
  },
  SET_INTERVAL_LOADING_END: (state) => {
    state.interval.loading = false
  },
  SAVE_INTERVAL_ERROR: (state, error) => {
    state.interval.error = error
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}


